import type { Movie } from '@/mocks/movies';

const qualityStyles: Record<string, string> = {
  '4K蓝光': 'bg-accent-500 text-foreground-950',
  '1080P蓝光': 'bg-primary-500 text-background-50',
  'HD高清': 'bg-secondary-500 text-background-50',
};

export default function MovieCard({ movie }: { movie: Movie }) {
  return (
    <article className="group flex flex-col rounded-lg border border-background-200 bg-background-50 overflow-hidden transition-all duration-300 hover:border-primary-300 hover:-translate-y-1">
      <div className="relative w-full aspect-[2/3] overflow-hidden">
        <img
          src={movie.poster}
          alt={`${movie.title} 影片海报`}
          title={`${movie.title} 高清下载`}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/75 via-transparent to-transparent"></div>
        <span className={`absolute top-2 left-2 px-2 py-0.5 rounded-md text-[11px] font-medium ${qualityStyles[movie.quality] || 'bg-secondary-500 text-background-50'}`}>
          {movie.quality}
        </span>
        <span className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-background-50/90 text-foreground-900 text-[11px] font-semibold">
          {movie.rating.toFixed(1)}
        </span>
        <div className="absolute bottom-2 left-2 right-2">
          <h3 className="font-heading text-sm font-semibold text-background-50 truncate">{movie.title}</h3>
          <p className="text-[11px] text-background-200/90 truncate">{movie.originalTitle}</p>
        </div>
      </div>

      <div className="p-3 flex flex-col gap-2">
        <div className="flex flex-wrap items-center gap-1.5 text-[11px]">
          <span className="px-1.5 py-0.5 rounded bg-secondary-50 text-secondary-700 border border-secondary-200">{movie.year}</span>
          {movie.genres.map((g) => (
            <span key={g} className="px-1.5 py-0.5 rounded bg-background-100 text-foreground-600 border border-background-200">{g}</span>
          ))}
        </div>

        <p className="text-xs leading-relaxed text-foreground-600 line-clamp-2">{movie.desc}</p>

        <div className="pt-2 mt-auto border-t border-background-100 grid grid-cols-2 gap-y-1.5 text-[11px] text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-aspect-ratio-line"></i>
            {movie.resolution}
          </span>
          <span className="flex items-center gap-1 justify-end">
            <i className="ri-archive-line"></i>
            {movie.size}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-map-pin-line"></i>
            {movie.region}
          </span>
          <span className="flex items-center gap-1 justify-end text-accent-700">
            <i className="ri-fire-line"></i>
            热度 {movie.heat}
          </span>
        </div>
      </div>
    </article>
  );
}